import { render, staticRenderFns } from "./StepValidation.vue?vue&type=template&id=c2f9aa02&scoped=true&"
import script from "./StepValidation.vue?vue&type=script&lang=js&"
export * from "./StepValidation.vue?vue&type=script&lang=js&"
import style0 from "./StepValidation.vue?vue&type=style&index=0&id=c2f9aa02&lang=scss&scoped=true&"
import style1 from "./StepValidation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f9aa02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,FormList: require('/workspace/components/Form/FormList.vue').default})
